import { Payload } from "./payload";
export class DropItemEvent extends Payload{
    constructor(init?: Partial<DropItemEvent>) {
        super('DropItemEvent');
        Object.assign(this, init);
    }
    type: string = 'DropItemEvent';
    connectionId?: string;
    itemName!: string;
    x!: number;
    y!: number;
    scale!: number;
    levelName!: string;
}